var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"compare-container"},[_c('twenty-twenty',{attrs:{"before":_vm.imageBefore,"after":_vm.imageAfter}}),(_vm.caption)?_c('div',{staticClass:"compare-caption"},[_vm._v(_vm._s(_vm.caption))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }